<template>
    <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{lookupResult.TargetSystem.Name}} - {{translate('lookup')}}</h5>
                <button type="button" class="close" data-dismiss="modal"  aria-label="Kapat" @click="$emit('onclose')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" v-show="lookupResult.Files">
                    <div class="col">
                        <h5>{{translate('incomingDoc.uzakDizin')}}: {{lookupResult.TargetSystem.Path}}</h5>
                        <div class="form-control" style="height:400px; overflow-y:scroll; padding:0">
                            <table class="table table-striped table-sm table-borderless table-hover" style="margin-top:-1px">
                                <thead>
                                    <th style="width:1px"></th>
                                    <th>{{translate('approvalAuthorityEditor.name')}}</th>
                                    <th class="text-right">{{translate('targetSystemLookup.size')}}</th>
                                    <th class="text-right">{{translate('targetSystemLookup.lastChange')}}</th>
                                </thead>
                                <tbody>
                                    <tr v-for="e in sortedFiles" :key="e.Name" @click="e.IsDirectory ? $emit('ftpLookupTargetSystem', e.FullName) : null" v-bind:class="{ 'selectable ': e.IsDirectory }">
                                        <td>
                                            <icon-folder v-if="e.IsDirectory"/>
                                            <icon-file-earmark v-else />
                                        </td>
                                        <td>
                                            <span v-if="e.Name != '..'">{{e.Name}}</span>
                                            <b v-else>..</b>
                                        </td>
                                        <td class="text-right">
                                            <small v-if="!e.IsDirectory">{{e.Length | prettyBytes}}</small>
                                        </td>
                                        <td class="text-right">
                                            <span v-if="e.Name != '..'">{{e.LastWriteTime | datetime}}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer footer-button-container">
                <button type="button" class="btn btn-outline-secondary" @click="$emit('onclose')">{{translate('close')}}</button>
                <button type="button" class="btn btn-success" @click="$emit('ftpLookupPathSelected', lookupResult.TargetSystem.Path)">{{translate('choose')}}</button>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import iconFolder from '../components/Icons/folder.svg';
import iconFileEarmark from '../components/Icons/file-earmark.svg';

export default {
    props: {
        lookupResult: Object
    },
    components: {
        iconFolder,
        iconFileEarmark
    },
    created(){
        
    },
    computed:{
        sortedFiles(){
            if(this.lookupResult && this.lookupResult.Files){
                let sortedData = this.lookupResult.Files

                return sortedData.sort(this.compare);
            } else
            return [];
        }
    },
    methods: {
        compare(a, b) {
            if(a.Name == "..")
                return -1;
            
            if(b.Name == "..")
                return 1;
               
            if(a.IsDirectory > b.IsDirectory)
                return -1;
            
            if(b.IsDirectory > a.IsDirectory)
                return 1;
                
            return a.Name - b.Name;
        }
    }
}
</script>
<style scoped>
.selectable {
    cursor: pointer;
}
</style>